module.exports = __webpack_public_path__ + "static/media/oppo-indonesia-6.a734fa67.jpg";